import React, { useState, useEffect } from 'react';
import "../Admin/assete/css/viewdetails.css";
import { ViewDetailsApi , deleteDetailApi, updateReadStatusApi, updateContactMessageApi} from '../service/Api';
import Adminheader from './Adminheader';

const Viewdetails = () => {
    const [details, setDetails] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [detailToDelete, setDetailToDelete] = useState(null);
    const [editMessages, setEditMessages] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await ViewDetailsApi();
                if (response && response.contact_details) {
                    setDetails(response.contact_details.reverse());
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);

    const handleDelete = async () => {
        try {
            await deleteDetailApi(detailToDelete);
            setDetails(details.filter(detail => detail.id !== detailToDelete));
            setShowPopup(false);
        } catch (error) {
            console.error('Error deleting detail:', error);
        }
    };

    const openDeletePopup = (id) => {
        setDetailToDelete(id);
        setShowPopup(true);
    };

    const closeDeletePopup = () => {
        setShowPopup(false);
    };

    const markAsRead = async (id) => {
      try {
        // Call the API to update the read status
        const response = await updateReadStatusApi(id);
        if (response && response.status) {
          // Update the local state to reflect the change
          setDetails((prevDetails) =>
            prevDetails.map((detail) =>
              detail.id === id ? { ...detail, readed: "read" } : detail
            )
          );
        } else {
          console.error("Failed to update read status");
        }
      } catch (error) {
        console.error("Error marking as read:", error);
      }
    };

     const handleEditChange = (id, value) => {
        setEditMessages(prev => ({ ...prev, [id]: value }));
    };

    const handleSave = async (id) => {
        try {
            const newMessage = editMessages[id];
            if (!newMessage || newMessage.trim() === "") {
                alert("Message cannot be empty");
                return;
            }

            const response = await updateContactMessageApi(id, newMessage);
            if (response && response.status) {
                // Update local state
                setDetails(prevDetails =>
                    prevDetails.map(detail =>
                        detail.id === id ? { ...detail, message: newMessage } : detail
                    )
                );
                alert("Message updated successfully!");
            } else {
                alert("Failed to update message");
            }
        } catch (error) {
            console.error("Error updating message:", error);
        }
    };

  
    const sortedDetails = [...details].sort((a, b) => {
      if (a.readed === "read" && b.readed !== "read") return 1;
      if (a.readed !== "read" && b.readed === "read") return -1;
      return 0;
    });


  return (
    <>
    <Adminheader/>
    <div className='view_cont_div'>
     <div className='ad_det'>
                <h2>Contact Details</h2>
            </div>
            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Service Type</th>
                            <th>Message</th>
                             <th>Rewrite</th>
                            <th>View</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedDetails.map((detail, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{detail.name}</td>
                                <td>{detail.email}</td>
                                <td>{detail.phone}</td>
                                <td>{detail.service_type}</td>
                                <td style={{ maxWidth: '300px', maxHeight: '100px', overflow: 'auto' }}>{detail.message}</td>
                                 <td>
                                        <textarea
                                            value={editMessages[detail.id] || ""}
                                            onChange={(e) => handleEditChange(detail.id, e.target.value)}
                                            placeholder="Rewrite message"
                                            style={{ width: '200px', height: '60px' }}
                                        />
                                         <br />
                                        <button
                                            onClick={() => handleSave(detail.id)}
                                            style={{ backgroundColor: 'blue', color: 'white', padding: '5px 10px', marginTop: '5px' }}
                                        >
                                            Save
                                        </button>
                                    </td>
                                        
                                <td>  <button 
    onClick={() => markAsRead(detail.id)}
    style={{
      backgroundColor: detail.readed === "read" ? "green" : "orange",
      color: "white",
      border: "none",
      padding: "5px 10px",
      cursor: "pointer"
    }}
  >
    {detail.readed === "read" ? "Read" : "Unread"}
  </button></td>
                                <td><button onClick={() => openDeletePopup(detail.id)}>Delete</button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            
            {showPopup && (
                <div className="popup-container">
                    <div className="popup">
                        <h3>Are you sure you want to delete?</h3>
                        <div className="popup-buttons">
                            <button onClick={handleDelete}>Delete</button>
                            <button onClick={closeDeletePopup}>Cancel</button>
                        </div>
                    </div>
                </div>
                 
            )}
            </div>
    </>
  )
}

export default Viewdetails